import React from "react"
import { View } from "react-native"
import { Vertical } from "@/components/standard/BFLayout"
import { MilestoneItem } from "./MilestoneItem"
import type { MilestoneType } from "@/generated/graphql"
import { useQuery } from "@tanstack/react-query"
import { loanDashboardQueryOptions } from "@/queries/loan-dashboard"
import { router } from "expo-router"
import { loanAppLoanWizard } from "@/screens/loans/utils/LoanUtils"

interface MilestoneListProps {
  loanId: string
}

const VIEW_REQUESTS_ACTION = "View Requests"
const CONTINUE_QUOTE_ACTION = "Continue Quote Request"

export const MilestoneList: React.FC<MilestoneListProps> = ({ loanId }) => {
  const { data: loanApp } = useQuery({
    ...loanDashboardQueryOptions(loanId),
    select: (data) => {
      return data!
    },
  })

  const milestones = loanApp?.milestones

  if (!milestones) {
    return null
  }

  const handleMilestonePress = (milestone: MilestoneType) => {
    console.log("Milestone pressed:", milestone.name)
    // TODO: Navigate to milestone detail or perform action
  }

  const handleActionPress = (action: string, milestone: any) => {
    console.log("Action pressed:", action, "for milestone:", milestone.name)
    // TODO: Handle specific actions like "View Quote", "View Requests", etc.
    switch (action) {
      case CONTINUE_QUOTE_ACTION:
        router.push(loanAppLoanWizard(loanId))
        break
      case "View Quote":
        // Navigate to quote view
        break
      case VIEW_REQUESTS_ACTION:
        router.push("./requests")
        break
      default:
        break
    }
  }

  const handleProcessorContact = (
    type: "phone" | "message" | "schedule" | "email",
    milestone: any
  ) => {
    console.log("Processor contact:", type, "for milestone:", milestone.name)
  }

  // Special actions based on milestone type and status
  const getSpecialActions = (milestone: MilestoneType) => {
    const actions: string[] = []
    const isDisabled = milestone.status === "blocked"
    const hasTasks = milestone.tasks.length > 0

    // View Quote action for completed quote milestones
    if (milestone.name?.toLowerCase().includes("quote")) {
      if (milestone.status === "completed") {
        actions.push("View Quote")
      } else {
        actions.push(CONTINUE_QUOTE_ACTION)
      }
    }

    // View Requests action for milestones with tasks
    if (hasTasks && milestone.status !== "completed" && !isDisabled) {
      actions.push(VIEW_REQUESTS_ACTION)
    }

    return actions
  }

  return (
    <Vertical className={`gap-1`}>
      <View className="bg-card border border-border rounded p-5">
        {milestones.map((milestone, index) => (
          <MilestoneItem
            key={milestone.id}
            milestone={milestone}
            isLast={index === milestones.length - 1}
            specialActions={getSpecialActions(milestone)}
            onPress={() => {
              handleMilestonePress(milestone)
            }}
            onActionPress={(action) => {
              handleActionPress(action, milestone)
            }}
            onProcessorContact={(type) => {
              handleProcessorContact(type, milestone)
            }}
          />
        ))}
      </View>
    </Vertical>
  )
}
